import { useCallback, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useEntitlements() {
  const [credits, setCredits] = useState(0);
  const [allocatedCredits, setAllocatedCredits] = useState(0);
  const [creditsLoaded, setCreditsLoaded] = useState(false);
  const [isPremium, setIsPremium] = useState(false);

  const fetchCredits = useCallback(async (userId: string) => {
    for (let attempt = 0; attempt < 3; attempt++) {
      const { data } = await supabase
        .from('user_credits')
        .select('balance, is_premium, allocated_credits')
        .eq('user_id', userId)
        .maybeSingle();

      if (data && (data.balance > 0 || attempt === 2)) {
        setCredits(data.balance ?? 0);
        setAllocatedCredits((data as any)?.allocated_credits ?? 0);
        setIsPremium(data.is_premium ?? false);
        setCreditsLoaded(true);
        return;
      }

      if (attempt < 2) await new Promise(r => setTimeout(r, 1500));
    }

    setCredits(0);
    setAllocatedCredits(0);
    setCreditsLoaded(true);
  }, []);

  const reset = useCallback(() => {
    setCredits(0);
    setAllocatedCredits(0);
    setCreditsLoaded(false);
    setIsPremium(false);
  }, []);

  return {
    credits,
    allocatedCredits,
    creditsLoaded,
    isPremium,
    fetchCredits,
    reset,
  };
}
